import React from 'react';
import styles from './ClientTypes.module.css';

const ClientTypeStatistics = ({ statistics, loading }) => {
    if (loading) {
        return (
            <div className={styles.statisticsLoading}>
                <div className={styles.spinner}></div>
                <span>Loading statistics...</span>
            </div>
        );
    }

    return (
        <div className={styles.statisticsContainer}>
            <div className={styles.statisticsHeader}>
                <h3>Client Types Overview</h3>
                <p>Statistics about client types in the system</p>
            </div>
            <div className={styles.statisticsGrid}>
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Total Client Types</h4>
                        <span className={styles.statValue}>{statistics.total}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ width: '100%' }}
                        />
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Active Types</h4>
                        <span className={styles.statValue}>{statistics.active}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ width: `${(statistics.active / statistics.total) * 100}%` }}
                        />
                    </div>
                    <div className={styles.statFooter}>
                        <span className={styles.statPercentage}>
                            {statistics.total ? Math.round((statistics.active / statistics.total) * 100) : 0}% of total
                        </span>
                    </div>
                </div>
                <div className={styles.statCard}>
                    <div className={styles.statHeader}>
                        <h4 className={styles.statLabel}>Inactive Types</h4>
                        <span className={styles.statValue}>{statistics.inactive}</span>
                    </div>
                    <div className={styles.statBar}>
                        <div 
                            className={styles.statBarFill}
                            style={{ width: `${(statistics.inactive / statistics.total) * 100}%` }}
                        />
                    </div>
                    <div className={styles.statFooter}>
                        <span className={styles.statPercentage}>
                            {statistics.total ? Math.round((statistics.inactive / statistics.total) * 100) : 0}% of total
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientTypeStatistics;
